import React from 'react';
import { useTranslation } from 'react-i18next';
import LAdmin from '../layouts/LAdmin';
import { Helmet } from 'react-helmet';
import CAppTitle from '../../../app/components/CAppTitle';
import langAdminUserEmailNotifications from '../langs/langAdminUserEmailNotifications';
import FAdminUserEmailNotifications from '../features/user-email-notifications/FAdminUserEmailNotifications';

const PAdminUserEmailNotifications = () => {
	const { t } = useTranslation();
	return (
		<LAdmin>
			<Helmet>
				<title>IRP Admin tools - {t(langAdminUserEmailNotifications.title.tag)}</title>
			</Helmet>
			<CAppTitle
				title={t(langAdminUserEmailNotifications.title.tag)}
				id="title-admin-user-emails-notifications"
			/>
			<FAdminUserEmailNotifications />
		</LAdmin>
	);
};

export default PAdminUserEmailNotifications;
